export const EVENTIVAL_BACKOFFICE_ORIGIN = 'https://bo.eventival.com';

export const EVENTIVAL_KIND = {
    EVENT: 'event',
    SCREENING: 'screening',
    FILM_PACKAGE: 'film_package',
};

export function get_eventival_integration(setting) {
    const cfg = setting?.integrations?.eventival;
    if (!cfg?.name || !cfg?.year)
        return null;
    return cfg;
}

export function get_eventival_ref(screening) {
    const refs = screening?.refs;
    if (!Array.isArray(refs))
        return null;
    return refs.find(r => r?.source === 'eventival' && r?.id) || null;
}

export function get_eventival_kind(screening) {
    return screening?.opaque?.eventival?.type
        || screening?.films?.[0]?.opaque?.eventival?.type
        || null;
}

export function get_eventival_film_id(screening) {
    const id = screening?.films?.[0]?._id;
    if (id == null || id === '')
        return null;
    return String(id);
}

/**
 * Back-office URL for a Ticketack screening linked to Eventival.
 * Events: /{name}/{year}/events/{ref_id}
 * Screenings / film packages: /{name}/{year}/films/{film_id}/scheduling#
 */
export function build_eventival_backoffice_url(screening, setting) {
    const integration = get_eventival_integration(setting);
    const ref = get_eventival_ref(screening);
    if (!integration || !ref?.id)
        return null;

    const base = `${EVENTIVAL_BACKOFFICE_ORIGIN}/${integration.name}/${integration.year}`;
    const kind = get_eventival_kind(screening);

    if (kind === EVENTIVAL_KIND.EVENT)
        return `${base}/events/${ref.id}`;

    const film_id = get_eventival_film_id(screening);
    if (!film_id)
        return null;

    return `${base}/films/${film_id}/scheduling#`;
}

/**
 * Rebuilds a minimal screening from a screenings import log invalid entry (optional eventival meta).
 */
export function screening_from_import_invalid_entry(entry) {
    if (!entry)
        return null;

    const screening = {
        title: entry.title,
        start_at: entry.start_at,
        stop_at: entry.stop_at,
    };
    if (entry._id)
        screening._id = entry._id;

    if (entry.eventival?.ref_id) {
        screening.refs = [{ id: String(entry.eventival.ref_id), source: 'eventival' }];
        screening.opaque = {
            eventival: {
                ...(entry.eventival.type && { type: entry.eventival.type }),
            },
        };
        if (entry.eventival.film_id)
            screening.films = [{ _id: entry.eventival.film_id }];
    }

    return screening;
}
